import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import FormField from '../../ui/formField';
import moment from 'moment';
import './carrierUpload.css';
import CarrierUploadFormDropdown from './carrierUploadFormDropdown';
import CarrierUploadFormMultipleDropdown from './carrierUploadFormMultipleDropdown';
import TagInput from './tagInput';
import Header from '../../header';
import Footer from '../../footer';
import Loader from '../../loader';
import MatchingFormList from './matchingForm';
import { carrierUploadAction } from '../../../actions/carrierUploadAction';
import { formAdministrationAction } from '../../../actions/fromAdministrationAction';
import { useToast } from '../../notifications/ToastContext';
import axios from 'axios';
import CarrierBreadCrumb from '../carrierOnboard/carrierBreadCrumb';

const CarrierUploadForm = () => {
  const [showDataSaveLoader, setShowDataSaveLoader] = useState(false);
  const [formTypeSelected, setFormTypeSelected] = useState('');
  const [formName, setFormName] = useState('');
  const [productCategorySelected, setProductCategorySelected] = useState('');
  const [carrierSelected, setCarrierSelected] = useState([]);
  const [productTypeValues, setProductTypeValue] = useState([]);
  const [productTypeSelected, setProductTypeSelected] = useState([]);
  const [stateSelected, setStateSelected] = useState([]);
  const [carrierAttachemnt, setCarrierAttachment] = useState(null);
  const [fileUploadErr, setFileUploadErr] = useState('');
  const [formVersionNumber, setFormVersionNumber] = useState('');
  const [formDate, setFormDate] = useState(null);
  let productDisability = 'disability';
  let productGeneralForms = 'General Forms';
  let brokerDealerFormText = 'Broker Dealer Forms';
  const [brokerDealerFormId, setBrokerDealerFormId] = useState(null);
  let golcondaFormText = 'Golconda Forms';
  const [golcondaFormId, setGolcondaFormId] = useState(null);

  const navigate = useNavigate();
  const { addToast } = useToast();
  const handleShowToast = (message) => {
    const newToast = {
      id: Date.now(),
      type: 'success',
      message: message,
    };
    addToast(newToast);
  };

  const handleShowError = (message) => {
    const newToast = {
      id: Date.now(),
      type: 'error',
      message: message,
    };
    addToast(newToast);
  };

  const onFormNameChange = (e) => {
    const name = e.target.value.replace(/[^a-zA-Z0-9./\\_-\s]/g, '');
    setFormName(name);
  };
  const onCarrierAttachmentChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      if (file.type !== 'application/pdf') {
        setFileUploadErr(
          'Selected file type is not supported, please upload a PDF file'
        );
        setCarrierAttachment(null);
      } else if (file.size > 26214400) {
        setFileUploadErr('Please upload a file that is less than 25MB');
        setCarrierAttachment(null);
      } else {
        setFileUploadErr('');
        setCarrierAttachment(file);
      }
    } else {
      setFileUploadErr('');
      setCarrierAttachment(null);
    }
  };

  const handleSelectedTagsChange = (tags) => {
    setSelectedTags(tags);
  };

  const clearForm = () => {
    setCarrierAttachment(null);
    setFormTypeSelected('');
    setFormName('');
    setProductCategorySelected('');
    setCarrierSelected([]);
    setProductTypeSelected([]);
    setStateSelected([]);
    setCarrierAttachment(null);
    setFileUploadErr('');
    setSelectedTags([]);
    dispatch(carrierUploadAction());
  };

  const pageData = useSelector((state) => state.carrierUploadData);
  const existingFormsData = useSelector((state) => {
    const systemForms = state.formAdministrationData?.formData?.system || [];
    const uploadedForms =
      state.formAdministrationData?.formData?.uploaded || [];
    return [...systemForms, ...uploadedForms];
  });

  const { loading, formData } = pageData;

  const suggestedTags = formData?.category_tags ? formData.category_tags : [];
  const [selectedTags, setSelectedTags] = useState([]);
  const [matchingExistingForms, setMatchingExistingForms] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(carrierUploadAction());
    dispatch(formAdministrationAction());
  }, [dispatch]);

  const onUploadClick = () => {
    setShowDataSaveLoader(true);
    const payload = {
      form_types: formTypeSelected,
      form_name: formName,
      product_categories: productCategorySelected,
      carriers: JSON.stringify(carrierSelected),
      products: JSON.stringify(productTypeSelected),
      states: JSON.stringify(stateSelected),
      category_tags: JSON.stringify(selectedTags),
      pdf_file: carrierAttachemnt,
      form_version: formVersionNumber,
      form_date: formDate ? moment(formDate).format('YYYY-MM-DD') : null,
    };

    // Set a timeout to show success after 3 seconds
    const successTimeout = setTimeout(() => {
      setShowDataSaveLoader(false);
      handleShowToast('File Uploaded Successfully');
      navigate('/formadministration', { replace: true });
    }, 3000);

    axios({
      url: '/carrier-upload/save',
      method: 'POST',
      data: payload,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then((response) => {
        // Clear the timeout since the response came within 3 seconds
        clearTimeout(successTimeout);

        setShowDataSaveLoader(false);
        clearForm();
        handleShowToast('File Uploaded Successfully');
        navigate('/formadministration', { replace: true });
      })
      .catch(function (error) {
        // Clear the timeout in case of an error
        clearTimeout(successTimeout);

        setShowDataSaveLoader(false);
        handleShowError(
          'File Upload Failed!! Please contact the administrator'
        );
      });
  };

  const areArraysEqual = (array1, array2) => {
    if (array1.length !== array2.length) {
      return false;
    }
    for (let i = 0; i < array1.length; i++) {
      if (array1[i] !== array2[i]) {
        return false;
      }
    }
    return true;
  };

  const validateForm = useCallback(() => {
    const criteria = {
      product_category: productCategorySelected,
      carrier_id: carrierSelected,
      product_id: productTypeSelected,
    };

    const matchingForms = existingFormsData.filter((record) => {
      const isCategoryMatch =
        criteria.product_category &&
        record.product_category === criteria.product_category;
      const areCarrierIdsMatch =
        criteria.carrier_id?.length > 0 &&
        criteria.carrier_id.every((id) => record.carrier_id.includes(id));
      const areProductIdsMatch =
        criteria.product_id?.length > 0 &&
        criteria.product_id.every((id) => record.product_id.includes(id));

      return isCategoryMatch && areCarrierIdsMatch && areProductIdsMatch;
    });
    if (!areArraysEqual(matchingExistingForms, matchingForms)) {
      setMatchingExistingForms(matchingForms);
    }
  }, [
    productCategorySelected,
    carrierSelected,
    productTypeSelected,
    existingFormsData,
    matchingExistingForms,
  ]);

  useEffect(() => {
    validateForm();
  }, [validateForm]);

  useEffect(() => {
    // Initialize variables to store the found objects
    let brokerDealerFormObj;
    let golcondaFormObj;

    // Iterate over the carriers array to find both brokerDealerFormObj and golcondaFormObj
    formData?.carriers?.forEach((item) => {
      if (item?.carrier === brokerDealerFormText) {
        brokerDealerFormObj = item;
      } else if (item?.carrier === golcondaFormText) {
        golcondaFormObj = item;
      }
    });

    // Update state variables with the found IDs
    setBrokerDealerFormId(brokerDealerFormObj?.id);
    setGolcondaFormId(golcondaFormObj?.id);
  }, [formData?.carriers, brokerDealerFormText, golcondaFormText]); // Getting the ID's of Broker Dealer Form Carrier and Golconda Forms Carrier and assigning it in state

  useEffect(() => {
    //Selecting All the states if carrier is Broker Dealer Form or Golconda Form
    if (
      carrierSelected?.includes(brokerDealerFormId) ||
      carrierSelected?.includes(golcondaFormId)
    ) {
      let stateIds = formData?.states?.map((item) => item.id);
      setStateSelected(stateIds);
    }
  }, [formData?.states, carrierSelected]);

  useEffect(() => {
    let productTypeArr = formData?.products?.filter(
      (item) => item?.product_category === productCategorySelected
    );
    setProductTypeValue(productTypeArr);

    if (productCategorySelected.toLowerCase() === productDisability) {
      //if Category "Disability" is Selected
      const selectedObj = formData?.products?.find(
        (item) => item?.product_category?.toLowerCase() === productDisability
      );
      setProductTypeSelected([selectedObj?.id]);
    } else if (productCategorySelected === productGeneralForms) {
      //if Category "General Forms" is Selected
      const selectedObj = formData?.products?.find(
        (item) => item?.product_category === productGeneralForms
      );
      setProductTypeSelected([selectedObj?.id]);
    }
  }, [formData, productCategorySelected]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {' '}
          <Header />
          <div className="carrierUploadFormWrapper" id="contents">
            <CarrierBreadCrumb currentPageName={'Form Upload'} />
            <div className="carrierUploadForm">
              <h2 className="carrierUploadForm--heading">Form Upload</h2>
              <div className="carrierUploadForm--contents flex">
                <div className="label-value-wrapper layout-2">
                  <label className="field-label">
                    Carrier
                    <span className="carrierUploadForm--mandatoryField">*</span>
                  </label>
                  <div>
                    <CarrierUploadFormMultipleDropdown
                      setSelectedIds={setCarrierSelected}
                      options={formData?.carriers}
                      dropdownType="carriers"
                      labelKey="carrier"
                      hideAllText={true}
                    />
                  </div>
                </div>

                <div className="label-value-wrapper layout-2">
                  <label className="field-label">
                    State
                    <span className="carrierUploadForm--mandatoryField">*</span>
                  </label>
                  <div>
                    {carrierSelected?.includes(brokerDealerFormId) ||
                    carrierSelected?.includes(golcondaFormId) ? (
                      <input type="text" name="states" value="All" disabled />
                    ) : (
                      <CarrierUploadFormMultipleDropdown
                        setSelectedIds={setStateSelected}
                        options={formData?.states}
                        dropdownType="states"
                        labelKey="state"
                        labelDisplayKey="state_short_form"
                      />
                    )}
                  </div>
                </div>
                <div className="label-value-wrapper layout-2">
                  <label className="field-label">
                    Category
                    <span className="carrierUploadForm--mandatoryField">*</span>
                  </label>

                  <div>
                    <CarrierUploadFormDropdown
                      selected={productCategorySelected}
                      setSelected={setProductCategorySelected}
                      options={formData?.product_categories}
                      labelKey="product_category"
                    />
                  </div>
                </div>

                <div className="label-value-wrapper layout-2">
                  <label className="field-label">
                    Product
                    <span className="carrierUploadForm--mandatoryField">*</span>
                  </label>
                  <div>
                    {productCategorySelected?.toLowerCase() ===
                      productDisability ||
                    productCategorySelected === productGeneralForms ? (
                      <>
                        <input
                          type="text"
                          name="products"
                          placeholder="Enter"
                          value={productCategorySelected}
                          disabled
                        />
                      </>
                    ) : (
                      <CarrierUploadFormMultipleDropdown
                        setSelectedIds={setProductTypeSelected}
                        options={productTypeValues}
                        dropdownType="products"
                        labelKey="product"
                        hideAllText={
                          productCategorySelected === 'General Forms'
                            ? true
                            : false
                        }
                      />
                    )}
                  </div>
                </div>
                <div className="label-value-wrapper layout-2">
                  <label className="field-label">
                    Form Name
                    <span className="carrierUploadForm--mandatoryField">*</span>
                  </label>
                  <div>
                    <input
                      type="text"
                      name="formName"
                      id="carrierFormName"
                      placeholder="Enter"
                      value={formName}
                      onChange={onFormNameChange}
                      maxLength="100"
                    />
                  </div>
                </div>

                <div className="label-value-wrapper layout-2">
                  <label className="field-label">
                    Form Category
                    <span className="carrierUploadForm--mandatoryField">*</span>
                  </label>
                  <div>
                    <CarrierUploadFormDropdown
                      selected={formTypeSelected}
                      setSelected={setFormTypeSelected}
                      options={formData?.form_types}
                      labelKey="form_type"
                    />
                  </div>
                </div>
                <div className="label-value-wrapper layout-2">
                  <label className="field-label">Form Version Number</label>
                  <div>
                    <input
                      type="text"
                      name="formVersionNumber"
                      id="formVersionNumber"
                      placeholder="Enter version number"
                      value={formVersionNumber}
                      onChange={(e) => setFormVersionNumber(e.target.value)}
                      maxLength="100"
                    />
                  </div>
                </div>

                <div className="label-value-wrapper layout-2">
                  <label className="field-label">Form Date</label>
                  <div>
                    <FormField
                      type="date"
                      validationType="inputDate"
                      name="formDate"
                      max="3000-12-31"
                      placeholder="Enter"
                      value={formDate}
                      onChangeHandler={(date) => setFormDate(date.target.value)}
                    />
                  </div>
                </div>

                <div className="label-value-wrapper layout-1">
                  <label className="field-label">Category Tag </label>
                  <div>
                    <TagInput
                      suggestions={suggestedTags}
                      tags={selectedTags}
                      onTagAdd={handleSelectedTagsChange}
                      onTagRemove={handleSelectedTagsChange}
                    />
                  </div>
                </div>
                <div className="label-value-wrapper layout-1">
                  <label className="field-label">
                    Attachment (Upto 25MB)
                    <span className="carrierUploadForm--mandatoryField">*</span>
                  </label>
                  <div>
                    <input
                      type="file"
                      name="carrierUploadAttachment"
                      id="carrierUploadAttachment"
                      accept=".pdf"
                      onChange={onCarrierAttachmentChange}
                      hidden
                    />
                    <label
                      htmlFor="carrierUploadAttachment"
                      className="carrierUploadForm--customUpload"
                    >
                      <span className="carrierUploadForm-fileName">
                        {carrierAttachemnt
                          ? carrierAttachemnt.name
                          : 'Upload PDF file'}
                      </span>
                      <span className="carrierUploadForm-fileBrowse">
                        Browse
                      </span>
                    </label>
                  </div>
                  {fileUploadErr && (
                    <p className="carrierUpload-err">{fileUploadErr}</p>
                  )}
                </div>
              </div>

              {process.env.REACT_APP_ENABLE_FILTERS === 'Y' && (
                <MatchingFormList formData={matchingExistingForms} />
              )}

              <button
                className="button carrierUploadForm--button"
                disabled={
                  formTypeSelected &&
                  formName &&
                  productCategorySelected &&
                  carrierSelected.length > 0 &&
                  productTypeSelected.length &&
                  stateSelected.length &&
                  carrierAttachemnt
                    ? false
                    : true
                }
                onClick={onUploadClick}
              >
                Upload
              </button>
            </div>
          </div>
          <Footer />
        </>
      )}
      {showDataSaveLoader && <Loader />}
    </>
  );
};
export default CarrierUploadForm;
